import React from 'react';

const calculateAnswer = (props) => {
    const { 
        isWrittenNotice, isMoreThan3WeeksAgo, hasMoreThanTen,
        hasStarted6MonthsAgo, hasSpecialProtection, isInstantTermination
    } = props;

    if(!isWrittenNotice) {
        return 1;
    }
    if(isWrittenNotice && isMoreThan3WeeksAgo) {
        return 2;
    }
    if(isWrittenNotice && isInstantTermination) {
        return 3;
    }
    if(isWrittenNotice && hasStarted6MonthsAgo && hasMoreThanTen) {
        return 3;
    }
    if(isWrittenNotice && hasSpecialProtection) {
        return 3;
    }
    return 2;
}

const Result = (props) => {
    const answer = calculateAnswer(props);

    return (
        <div className={`inner`}>
            {(answer === 1)
            ? 
                <div className="answer__text">
                    <h2>Die Kündigung ist möglicherweise aus formellen Gründen unwirksam.</h2>
                    <p>
                        <strong>Nach § 623 BGB ist nur eine schriftliche Kündigung wirksam.</strong> Zögern 
                        Sie also nicht <a href="http://www.solmecke.eu/kontakt">Kontakt zu uns aufzunehmen</a>: 
                        Beachten Sie unbedingt, dass eine Klagefrist von 3 Wochen gilt. 

                        Sie müssen also innerhalb von 3 Wochen nach Zugang der schriftlichen Kündigung beim Arbeitsgericht 
                        Kündigungsschutzklage erheben. Sie sollten also schnellstmöglich <a href="http://www.solmecke.eu/kontakt">Kontakt 
                        aufnehmen</a>.
                    </p>
                </div>
            : ''}

            {(answer === 2)
            ? 
                <div className="answer__text">
                    <h2>Die Kündigung ist möglicherweise nicht angreifbar.</h2>
                    <p>
                        Dennoch sollten Sie unverbindlich und kostenlos <a href="http://www.solmecke.eu/kontakt">Kontakt zu uns 
                        aufnehmen</a>, um Ihre Angaben zu überprüfen. Neben der Anwendbarkeit des Kündigungsschutzgesetzes kann 
                        es weitere Gründe geben, nach denen sich die Unwirksamkeit der Kündigung ergibt.
                    </p>
                </div>
            : ''}

            {(answer === 3)
            ?
                <div className="answer__text">
                    <h2>Die Kündigung ist nach Ihren Angaben angreifbar.</h2>
                    <p>
                        Zögern Sie also nicht <a href="http://www.solmecke.eu/kontakt">Kontakt zu uns aufzunehmen</a>: 
                        Beachten Sie unbedingt, dass eine Klagefrist von 3 Wochen gilt. 

                        Sie müssen also innerhalb von 3 Wochen nach Zugang der schriftlichen Kündigung beim Arbeitsgericht 
                        Kündigungsschutzklage erheben. Sie sollten also schnellstmöglich <a href="http://www.solmecke.eu/kontakt">Kontakt 
                        aufnehmen</a>.
                    </p>
                </div>
            : ''}

            <div className="answer__text disclaimer">
                <p>
                    <strong>Haftungsausschluss</strong><br />
                    Die Überprüfung ersetzt keine Rechtsberatung für den konkreten Sachverhalt im Einzelfall, 
                    sondern gibt lediglich eine erste Einschätzung anhand allgemeiner Prüfungskriterien. Eine 
                    Haftung für das Prüfungsergebnis im Rahmen unseres Kündigungschecks wird daher nicht übernommen.
                </p>
            </div>
        </div>
    );
}

export default Result;


// WEBPACK FOOTER //
// ./src/components/partial.result.js